var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"relative"},[_c('div',{staticClass:"px-6 py-4",class:{ 'border-b border-grey-lighter': !_vm.hidden },on:{"click":function($event){_vm.hidden = ! _vm.hidden}}},[_vm._t("header")],2),_vm._v(" "),(!_vm.hidden)?_c('div',{staticClass:"px-6 py-4"},[_vm._t("default")],2):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51709e54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CollapseableBox.vue
// module id = null
// module chunks = 